import { PropsWithChildren } from 'react'

import * as Styled from './styles'

export const TableFooter = ({ children }: PropsWithChildren) => {
  return <Styled.TableFooterWrapper>{children}</Styled.TableFooterWrapper>
}
